import { styled } from '@mui/material'
import { FormItemStyled } from 'fwork.react.apptemplate'
import { FormStyledProps } from 'fwork.react.apptemplate/src/components/forms'
import React from 'react'

interface CtrlParamsItemHoverStyledProps {
  selected?: boolean
}

const CtrlParamsItemHoverStyled = styled('div')<CtrlParamsItemHoverStyledProps>(({ theme, selected }) => ({
  '&::before': selected ? {
    content: '""',
    background: '#ECECED',
    position: 'absolute',
    top: -5,
    bottom: -5,
    right: -5,
    left: -5,
    borderRadius: 8,
    zIndex: -1,
  } : undefined,
  ':hover': {
    '&::before': {
      content: '""',
      background: '#ECECED',
      position: 'absolute',
      top: -5,
      bottom: -5,
      right: -5,
      left: -5,
      borderRadius: 8,
      zIndex: -1,
    },
  },
}))

const CtrlParamsItemStyled = styled(FormItemStyled)(({ theme }) => ({
  position: 'relative',
  borderRadius: 8,
  cursor: 'pointer'
}))

interface CtrlParamsItemComponentProps extends FormStyledProps, React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  hover?: boolean,
  selected?: boolean,
}

export const CtrlParamsItemComponent = (props: CtrlParamsItemComponentProps) => {
  const { hover, selected, ...rest } = props
  return <CtrlParamsItemStyled {...rest} >
    {hover ? <CtrlParamsItemHoverStyled selected={selected} >
      {props.children}
    </CtrlParamsItemHoverStyled> : props.children}
  </CtrlParamsItemStyled>
}